import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

/**
 * This hook is similar to useDevice, but allows you to specify "breakpoint bumps"
 * which are added to the default breakpoints. Useful when you have a component/view
 * that doesn't well on the default breakpoints
 * @param breakpointBumps
 */
const useCustomDevice = (breakpointBumps: { lg?: number; md?: number; sm?: number }) => {
    const theme = useTheme()

    const lg = theme.breakpoints.values.lg + (breakpointBumps.lg ?? 0)
    const md = theme.breakpoints.values.md + (breakpointBumps.md ?? 0)
    const sm = theme.breakpoints.values.sm + (breakpointBumps.sm ?? 0)

    const mdScreen = useMediaQuery(theme.breakpoints.down(lg))
    const smScreen = useMediaQuery(theme.breakpoints.down(md))
    const xsScreen = useMediaQuery(theme.breakpoints.down(sm))
    return { mdScreen, smScreen, xsScreen }
}

export default useCustomDevice
